import NotificationSettingCard from './NotificationSettingCard.vue';

export default NotificationSettingCard;
